import { routes as routesGallery } from '@unicaiot/unica-iot-gallery-core'

export const routes = {
    ...routesGallery,
    explorer: '/explorer',
    registration: (id: string = ':id'): string => `/registration/${id}`,
}
